import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'

import useGetMyFranchise from 'entity/franchise/useGetMyFranchise'

import DTStyle from 'shared/style/detailTableStyle'
import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import TableLoading from 'shared/ui/TableLoading'
import {ROLE_FRANCHISE_MANAGER} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import check from './asset/check.svg'
import checked from './asset/checked.svg'
import usePutStoreManagerApprove from 'entity/store/usePutStoreManagerApprove'
import useDeleteStoreManagerApprove from 'entity/store/useDeleteStoreManagerApprove'

const MyFranchiseStoreList = () => {
	const navigate = useNavigate()
	const [userRole] = useRoleCookie()

	const [myFranchiseData, isLoading, refetchFranchise] = useGetMyFranchise()
	const [approveManager] = usePutStoreManagerApprove(refetchFranchise)
	const [unapproveManager] = useDeleteStoreManagerApprove(refetchFranchise)
	const isFranchiseOwner = myFranchiseData?.data?.franchise_manager?.is_mine

	const sizeList = isFranchiseOwner
		? ['short', 'expand', 'expand', 'expand', 'medium', 'short', 'long']
		: ['short', 'expand', 'expand', 'expand', 'medium', 'long']
	const tableHeadList = isFranchiseOwner
		? [
				'IDX',
				'매장명',
				'매니저 이름',
				'관리자 연락처',
				'상태',
				'승인',
				'구독 날짜',
			]
		: ['IDX', '매장명', '매니저 이름', '관리자 연락처', '상태', '구독 날짜']

	const handleNavigate = (idx) => {
		if (userRole === ROLE_FRANCHISE_MANAGER) {
			navigate(`/list/store/${idx}/detail`)
			return
		}
	}

	const btnList = isFranchiseOwner
		? [
				{
					label: '매장 매니저 계정 생성',
					clickEvent: () => navigate('/list/store/create'),
				},
			]
		: []

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList}>프랜차이즈 매장 목록</MainHeader>

			<Style.AreaDiv>
				<h2>매장 목록</h2>

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									{elem}
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{myFranchiseData?.data?.store_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => handleNavigate(elem?.idx)}
							>
								<TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>
									{elem?.store_name}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>{elem?.contact}</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>
									{elem?.is_approve ? '승인' : '미승인'}
								</TStyle.Data>
								{isFranchiseOwner && (
									<TStyle.Data
										$size={sizeList[5]}
										onClick={(e) =>
											elem?.is_approve
												? unapproveManager(e, elem?.idx)
												: approveManager(e, elem?.idx)
										}
									>
										<Style.Radio>
											<img
												src={elem?.is_approve ? checked : check}
												alt='approval-status'
											/>
										</Style.Radio>
									</TStyle.Data>
								)}
								<TStyle.Data $size={sizeList[isFranchiseOwner ? 6 : 5]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableDiv>
				</TableLoading>
			</Style.AreaDiv>
		</Style.Wrapper>
	)
}

export default MyFranchiseStoreList
